import { useState, useEffect } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { XMarkIcon } from "@heroicons/react/24/outline";
import { useDispatch } from "react-redux";
import { editProspects, getProspects } from "../../../slices/prospectSlice";

export default function ModalEditProspect({
  isModalEdit,
  setIsModalEdit,
  prospect,
  errorMessage,
  success,
}) {
  const dispatch = useDispatch();

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    description: "",
    newIdea: "",
    namePodcast: "",
  });

  useEffect(() => {
    if (prospect) {
      setFormData({
        name: prospect.name,
        email: prospect.email,
        phone: prospect.phone,
        description: prospect.description,
        newIdea: prospect.newIdea,
        namePodcast: prospect.namePodcast,
      });
    }
  }, [prospect]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleEditProspect = async (e) => {
    e.preventDefault();
    try {
      await dispatch(
        editProspects({ id: prospect._id, prospect: formData })
      ).unwrap();
      dispatch(getProspects());
      setIsModalEdit(false);
      success();
      setFormData({
        name: "",
        email: "",
        phone: "",
        description: "",
        newIdea: "",
        namePodcast: "",
      });
    } catch (error) {
      console.error(error);
      errorMessage();
    }
  };

  const handleExitModalEdit = () => {
    setIsModalEdit(false);
    setFormData({
      name: "",
      email: "",
      phone: "",
      description: "",
      newIdea: "",
      namePodcast: "",
    });
  };

  if (!prospect) {
    return null;
  }

  return (
    <AnimatePresence>
      {isModalEdit && (
        <motion.div
          key="modal-background"
          onClick={handleExitModalEdit}
          className="fixed inset-0 bg-black/50 flex items-center justify-center z-20"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.2, ease: "easeOut" }}
        >
          <motion.div
            key="modal-content"
            onClick={(e) => e.stopPropagation()}
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            transition={{ duration: 0.2, ease: "easeOut" }}
            className="bg-background rounded-xl shadow-2xl p-5 font-poppins w-[500px] mx-4 border border-gray-100"
          >
           
            <div className="flex justify-between items-center sm:mb-8 mb-2 ">
              <h3 className="text-2xl font-bold text-text">
                Editar Prospecto
              </h3>
              <button
                onClick={handleExitModalEdit}
                className="p-2 rounded-full hover:bg-gray-100 transition-colors"
              >
                <XMarkIcon className="w-6 h-6 text-gray-500" />
              </button>
            </div>

           
            <form onSubmit={handleEditProspect} className="sm:space-y-6 space-y-3 ">
             
              <div className="flex flex-col space-y-2">
                <label className="text-sm font-medium text-text">
                  Nombre
                </label>
                <input
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  className="w-full px-4 py-2 rounded-lg bg-background text-text border border-border focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>

             
              <div className="flex flex-col space-y-2">
                <label className="text-sm font-medium text-text">
                  Email
                </label>
                <input
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  className="w-full px-4 py-2 rounded-lg border border-border text-text bg-background focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>

            
              <div className="flex flex-col space-y-2">
                <label className="text-sm font-medium text-text">
                  Teléfono
                </label>
                <input
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  className="w-full px-4 py-2 rounded-lg border border-border text-text bg-background focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>

           
              <div className="flex flex-col space-y-2">
                <label className="text-sm font-medium text-text">
                  Descripción
                </label>
                <textarea
                  name="description"
                  value={formData.description}
                  onChange={handleChange}
                  className="w-full px-4 py-2 rounded-lg border border-border text-text bg-background focus:outline-none focus:ring-2 focus:ring-blue-500"
                  rows="2"
                />
              </div>

             
              <div className="flex flex-col space-y-2">
                <label className="text-sm font-medium text-text">
                  Nueva Idea
                </label>
                <select
                  name="newIdea"
                  value={formData.newIdea}
                  onChange={handleChange}
                  className="w-full px-4 py-2 rounded-lg border border-border text-text bg-background focus:outline-none focus:ring-2 focus:ring-blue-500"
                >
                  <option value={true}>Sí</option>
                  <option value={false}>No</option>
                </select>
              </div>

          
              <div className="flex flex-col space-y-2">
                <label className="text-sm font-medium text-text">
                  Podcast
                </label>
                <input
                  name="namePodcast"
                  value={formData.namePodcast}
                  onChange={handleChange}
                  className="w-full px-4 py-2 rounded-lg border border-border text-text bg-background focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>

            
              <div className="mt-8 flex justify-end">
                <button
                  type="submit"
                  className="px-6 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-colors"
                >
                  Guardar Cambios
                </button>
              </div>
            </form>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}